<ul class="existing-documents" *ngIf="documents.length; else noDocuments">
    <li *ngFor="let doc of documents" class="document-row" [class.document-row--inactive]="!doc.isActive">
        <span app-badge [color]="doc.isActive ? 'success' : 'neutral'" appearance="tonal" size="xs">
            {{ doc.isActive ? 'Ativo' : 'Inativo' }}
        </span>
        <span class="document-label">Laudo - Emitido em {{ doc.createdAt | date:'DD/MM/YYYY' }}</span>
        <a app-button appearance="tonal" color="info" size="xs" [href]="doc.url" target="_blank" rel="noopener"
            matTooltip="Abrir laudo" matTooltipPosition="above">
            <span app-button-content>
                <i class="icon--file-medical icon--md"></i>
            </span>
        </a>
        <button
            app-button
            appearance="tonal"
            color="danger"
            size="xs"
            [disabled]="updatingDocumentId === doc.id"
            [matTooltip]="doc.isActive ? 'Inativar' : 'Reativar'"
            matTooltipPosition="above"
            (click)="toggleActiveStatus(doc)"
        >
            <span app-button-content>
                <i [class]="doc.isActive ? 'icon--trash icon--md' : 'icon--rotate-right icon--md'"></i>
            </span>
        </button>
    </li>
</ul>
<ng-template #noDocuments>
    <p class="no-documents">Nenhum documento anexado a esta consulta.</p>
</ng-template>
